import React, { useState } from 'react'
import DuplicatePostManagement from '../components/DuplicatePostManagement/DuplicatePostManagement'

const DuplicatePostManagementPage = () => {
  return (
    <>
      <DuplicatePostManagement />
    </>
  )
}

export default DuplicatePostManagementPage
